export enum SegmentWidth {
    Wrap,
    Fill,
}
